module.exports = {"510113002":"大弯街道","510113003":"大同街道","510113102":"弥牟镇","510113104":"城厢镇","510113106":"姚渡镇","510113108":"清泉镇","510113111":"福洪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510113.json
// module id = 2388
// module chunks = 0